import { Injectable, Type } from '@angular/core';
import { Category, CategoryNaturalKey } from '../../../documents/models/category';
import { ApplicationTrainingUploadComponent } from './general/application-training-upload.component';
import { GeneralCommunicationsUploadComponent } from './general/general-communications-upload.component';
import { GeneralLabManualsUploadComponent } from './general/general-lab-manuals-upload.component';
import { GeneralTrainingMaterialsUploadComponent } from './general/general-training-materials-upload.component';
import { LabManualsUploadComponent } from './site-specific/lab-manuals-upload.component';
import { SiteActionsUploadComponent } from './site-specific/site-actions-upload.component';
import { SiteCommunicationsUploadComponent } from './site-specific/site-communications-upload.component';
import { SponsorCommunicationsUploadComponent } from './site-specific/sponsor-communications-upload.component';
import { TrainingMaterialsUploadComponent } from './site-specific/training-materials-upload.component';
import { UploadDialogBase } from './base/upload-dialog-base';

@Injectable()
export class UploadDialogTypeResolver {
    private readonly dialogTypesDictionary: { [key in CategoryNaturalKey]?: Type<UploadDialogBase> } = {
        'general-communications': GeneralCommunicationsUploadComponent,
        'general-manuals': GeneralLabManualsUploadComponent,
        'general-training-materials': GeneralTrainingMaterialsUploadComponent,
        'application-training': ApplicationTrainingUploadComponent,
        'lab-manuals': LabManualsUploadComponent,
        'site-communications': SiteCommunicationsUploadComponent,
        'site-actions': SiteActionsUploadComponent,
        'sponsor-communications': SponsorCommunicationsUploadComponent,
        'training-materials': TrainingMaterialsUploadComponent,
    };

    public getDialogType(category: Category): Type<UploadDialogBase> {
        return this.dialogTypesDictionary[category.categoryId];
    }
}
